import React, { useEffect, useRef } from 'react';
import useMst from '~/src/hooks/useMst';
import qs from 'qs';

import { useLayoutContext } from '~/src/contexts/Layout';
import { useObserver } from 'mobx-react';
import { CLIO_ERROR_STATE } from '../../utils/constants';
import ClioSyncErrorBanner from '../../components/Banner/ClioSyncErrorBanner';
import { LAYOUT_MODAL_TYPES } from '../../components/PageLayout/Modals';
import { clioManageMatterDocumentsLink } from '../../utils/clio';
import { history } from '../../utils/history';
import { useSyncSingleMatterModal } from '../../components/SingleMatterSync/useSyncSingleMatterModal';

const LibraryContainer = (props) => {
  const clioMatterIdRef = useRef(null);

  const { clioStore, clioErrorState } = useMst((store) => ({
    clioStore: store.clio,
    // eslint-disable-next-line react-hooks/rules-of-hooks
    clioErrorState: useObserver(() => store.clio.errorState),
  }));

  const { showModal } = useLayoutContext();

  const showNoCourtFormsModal = (clioMatterId) => {
    showModal(LAYOUT_MODAL_TYPES.error, {
      onSubmit: () =>
        (window.location.href = clioManageMatterDocumentsLink(clioMatterId)),
      messages: [
        "Your account doesn't have access to court form automation and therefore can't draft or edit court forms in Clio Draft.",
        'To add court form automation to your account, contact Clio Draft support.',
      ],
      submitButtonName: 'Return to Clio',
      title: 'Court forms not found',
    });
  };

  const handleSynced = (matterId) => {
    if (matterId && clioMatterIdRef.current) {
      clioStore.setCourtFormParams({
        syncedMatterId: matterId,
        courtFormClioMatterId: clioMatterIdRef.current,
      });
    }
  };

  const [{ sync }, modal] = useSyncSingleMatterModal('Library', handleSynced, {
    onError: (err) => {
      const clioMatterId = clioMatterIdRef.current;
      if (err?.response?.status === 403) {
        showNoCourtFormsModal(clioMatterId);
      } else if (err?.response?.status === 417) {
        clioStore.setErrorState(CLIO_ERROR_STATE.SYNC_NOT_ENABLED);
      } else if (err?.response?.status === 404) {
        clioStore.setErrorState(CLIO_ERROR_STATE.MATTER_SYNC_NOT_ENABLED);
      } else if (err?.response?.status === 423) {
        clioStore.setErrorState(CLIO_ERROR_STATE.SYNC_IN_QUEUE_OR_IN_PROGRESS);
      } else {
        clioStore.setErrorState(CLIO_ERROR_STATE.GENERIC_SYNC);
      }
    },
  });

  // fetch and store query params
  useEffect(() => {
    const { clio_matter_id } = qs.parse(history.location.search, {
      ignoreQueryPrefix: true,
    });

    if (clio_matter_id) {
      clioMatterIdRef.current = clio_matter_id;
      sync(clio_matter_id);
    } else {
      // when user navigates to library route/ with no valid query params, reset store variables
      clioStore.clearCourtFormParams();
      clioStore.clearErrorState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {clioErrorState && (
        <ClioSyncErrorBanner
          errorState={clioErrorState}
          onDismiss={() => clioStore.setErrorState(undefined)}
        />
      )}
      {modal}
      {props.children}
    </>
  );
};

export default LibraryContainer;
